import { Component,EventEmitter,Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BeneficiarioCriptomoneda } from 'src/app/dashboard/interfaces/beneficiario-criptomoneda.interface';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { ErrorTypes } from 'src/app/shared/enums/error-types.enum';
import { TipoPago } from 'src/app/shared/enums/tipo-pago.enum';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { MediosCriptoService } from 'src/app/dashboard/services/medios-cripto.service';
import {
  esErrorRedInactiva,
  etiquetaRed,
  mensajeRedInactiva,
  redDeBeneficiario,
} from 'src/app/shared/utils/red-cripto';

@Component({
  selector: 'app-summary-order',
  templateUrl: './summary-order.component.html',
  styleUrls: ['./summary-order.component.sass']
})
export class SummaryOrderComponent {

  constructor(
    private spinnerService: SpinnerService,
    private transaccionService: TransaccionService,
    private router: Router,
    private actionService: ActionsService,
    private mediosCripto: MediosCriptoService,
    ){}

  @Input()
  public clpCurrency: number = 0;

  @Input()
  public usdCurrency: number = 0;

  @Input()
  public usdt_clp_tax: number = 0;

  @Input()
  public valorCambioId: number = 0;

  @Input()
  public beneficiario: BeneficiarioCriptomoneda | undefined;

  @Output()
  public goBack = new EventEmitter<any>();

  /**
   * La red por la que se paga. Ahora que no es siempre TRC20, el resumen la
   * muestra: es lo último que el cliente mira antes de mandar la plata a esa
   * dirección.
   */
  get redBeneficiario(): string {
    return this.beneficiario
      ? etiquetaRed(redDeBeneficiario(this.beneficiario), this.beneficiario.medioCriptomoneda_descripcion)
      : '';
  }


  /**
   * 30/10/2026: la calculadora vuelve a consultar si el canal USDT sigue
   * abierto (Horario de Operaciones) justo antes de confirmar. Al entrar ya se
   * miraba, pero un cierre del operador con la pantalla abierta no frenaba la
   * transacción. Devuelve false si está cerrado; en ese caso ya avisó.
   */
  @Input()
  public verificarOperacion?: () => Promise<boolean>;

  async confirmarEnvio(){
    if (this.verificarOperacion && !(await this.verificarOperacion())) {
      return;
    }
    const ref = this.spinnerService.start();

    const transaccionDTO ={
      "paisOrigen":'CL',
      "userId":this.beneficiario?.beneficiario_user_id,
      "totalMonedaOrigen": +this.clpCurrency,
      "totalMonedaDestino": this.usdCurrency,
      "monedaOrigen":'CLP',
      "monedaDestino":'USDT',
      "paisDestino":'CRIPTOMONEDA',
      "formaPago":TipoPago.WALLET,
      "diferencia":null,
      "tasa": this.usdt_clp_tax,
      "beneficiarioCriptoId":this.beneficiario?.beneficiario_id,
      "tasaCambioId":null,
      "valorCambioId":this.valorCambioId,
      "tipoTransaccion": 'CRIPTO'
    }

    try{
      if((transaccionDTO.totalMonedaOrigen!==0&&transaccionDTO.totalMonedaOrigen!==null)||(this.usdCurrency<50)){
        const resultadoTransaccion = await this.transaccionService.saveTransaccion(transaccionDTO);
      }else{
        this.spinnerService.stop(ref);
        Swal.fire('Error al enviar dinero','Ha ocurrido un error al realizar la transferencia', 'warning').then(()=>{
          this.goToBack();
        });
        return
      }
      this.spinnerService.stop(ref);
      Swal.fire('Transaccion creada', `Se ha creado la transaccion con éxito`, 'success' );
      this.router.navigate(['/wallet/client/cripto-home']);

    }catch(error: any){
      if (esErrorRedInactiva(error)) {
        // 422 `RED_CRIPTO_INACTIVA`: la red del beneficiario se pausó entre
        // que lo eligió y confirmó. No se creó nada, así que no tiene sentido
        // mandarlo al inicio como en el error genérico: vuelve a elegir
        // beneficiario, donde la lista ya lo muestra pausado.
        this.spinnerService.stop(ref);
        this.mediosCripto.invalidar();
        await Swal.fire({
          icon: 'warning',
          title: 'Red pausada',
          text: mensajeRedInactiva(error),
          confirmButtonText: 'Elegir otro beneficiario',
          confirmButtonColor: '#1e5a3f',
        });
        this.goToBack();
        return;
      }
      if(error.status === 400 && error.error.type === ErrorTypes.TASAS_ACTUALIZADAS){
        this.spinnerService.stop(ref);
        this.actionService.emitirAccionTasaUSDT();
      }else{
        Swal.fire('Error al enviar dinero','Ha ocurrido un error al realizar la transferencia', 'warning').then(()=>{
          this.spinnerService.stop(ref);
          this.router.navigate(['/wallet/client/cripto-home']);
        });
      }

    }
  }

  goToBack(): void {
    this.goBack.emit();
  }

}
